import type { CharterPromotionPricingInventoryRow } from '~/types/charterPromotionPricingInventory';

import { getCharterCabinLabel } from '../FriendAndFamily/charterAirports';

export const PROMOTION_CSV_HEADERS = [
  'Date',
  'Route',
  'Cabin',
  'Eligibility',
  'Available Days Before',
  'Promotion Allocation',
  'ADT Price',
  'CHD Price',
  'Total Booked',
  'Open for Sale',
];

export function getPromotionCsvRows(rows: Array<CharterPromotionPricingInventoryRow>): Array<Record<string, unknown>> {
  return rows.map((row) => ({
    Date: row.date,
    Route: row.route,
    Cabin: getCharterCabinLabel(row.cabin),
    Eligibility: row.eligibility,
    'Available Days Before': row.availableDaysBefore,
    'Promotion Allocation': row.promotionAllocation,
    'ADT Price': row.adultPrice,
    'CHD Price': row.childPrice,
    'Total Booked': row.totalBooked,
    'Open for Sale': row.openForSale,
  }));
}

export function getPromotionCsvFilename(promotionLabel: string, exportDate: string): string {
  const promotionFileName = promotionLabel
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  return `charter-promotions-${promotionFileName}-${exportDate}.csv`;
}
